import { Component, OnInit, OnChanges, OnDestroy, QueryList, SimpleChanges, Input, ViewChild, ViewChildren, ElementRef } from '@angular/core';

import { Doc } from '../../../models/doc';
import { DocumentPart } from '../../../models/document-part';
import { DocTemplate } from '../../../models/doc-template';
import { DocPart } from '../../../models/doc-part';

import { AlertService } from '../../../services/common/alert.service';
import { AuthService } from '../../../services/common/auth.service';
import { DocumentChannelService } from '../../../services/channels/document-channel.service';
import { DocumentService } from '../../../services/documents/document.service';
import { DocumentStoreService } from '../../../services/documents/document-store.service';
import { FaviconService } from '../../../services/common/favicon.service';
import { MatterStoreService } from '../../../services/matters/matter-store.service';
import { ModalService } from '../../../services/common/modal.service';
import { TinymceService } from '../../../services/common/tinymce.service';

import { DocTemplateSearchComponent } from '../../common/doc-template-search/doc-template-search.component';
import { TinymceCssComponent } from '../../common/tinymce-css/tinymce-css.component';
import { DocumentSidebarComponent } from '../document-sidebar/document-sidebar.component';
import { LoggerService } from 'src/app/services/common/logger.service';

declare var jQuery: any;
declare var window: any;

@Component({
  selector: 'app-document-form',
  templateUrl: './document-form.component.html',
  styleUrls: ['./document-form.component.css'],
})
export class DocumentFormComponent implements OnInit, OnDestroy {
  @Input() matter_id: any;
  @Input() matter_info: any;

  calculatingWordCount: boolean = false;

  docTemplateItem: any;
  docTemplateTempItem: any;

  doc: Doc | null;

  docTemplate: DocTemplate | null;
  docParts: Array<DocPart> | null;

  formOptions: any;

  templateFooter: string | null;
  templateHeader: string | null;
  stylesheets_selected: Array<any> | null;
  templateClass: string | null;
  templateReturnData: Array<any> | null;

  css_content: any;
  css_files: any;
  stylesheet_formats: any;

  oldWordCount: number = 0;
  templateWordCount: number = 0;
  //tinymceCssComponents: QueryList<TinymceCssComponent>;
  totalWordCount: number = 0;

  signature_matter_user_id: number | null;

  showDocTemplateEdit: boolean = false;

  @ViewChild('previewIframe') previewIframeElement: ElementRef;

  @ViewChild(DocTemplateSearchComponent, { static: true }) docTemplateSearchComponent: DocTemplateSearchComponent;

  @ViewChildren('tinymceCss') tinymceCssComponents: QueryList<TinymceCssComponent>; //setTinymceCssComponents(tinymceCssComponents: QueryList<TinymceCssComponent>) {
  //	this.tinymceCssComponents = tinymceCssComponents;
  //}

  docPartColumns: Array<string> = ['name', 'contents', 'type', 'expand_part'];

  constructor(
    private alertService: AlertService,
    private authService: AuthService,
    private documentChannelService: DocumentChannelService,
    private documentService: DocumentService,
    private documentStoreService: DocumentStoreService,
    private faviconService: FaviconService,
    private loggerService: LoggerService,
    private matterStoreService: MatterStoreService,
    private modalService: ModalService,
    private tinymceService: TinymceService
  ) {
    this.documentStoreService.documentFormComponent = this;
  }

  // Component lifecycle events
  ngOnInit() {
    this.authService.getCurrentUserGroups().then((response_json) => {
      if (this.authService.getUser().is('admin editor tech')) this.showDocTemplateEdit = true;
      else this.showDocTemplateEdit = false;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.matter_id && changes.matter_id.currentValue) {
      this.docTemplateSearchComponent.clearSelectedDocTemplate();
      this.docTemplateItem = null;
      this.docTemplateTempItem = null;
      this.doc = null;
      this.docTemplate = null;
      this.docParts = null;
      this.templateFooter = null;
      this.templateHeader = null;
      this.stylesheets_selected = null;
      this.templateClass = null;
      this.templateReturnData = null;
      this.css_content = null;
      this.css_files = null;
      this.stylesheet_formats = null;
      this.signature_matter_user_id = null;
      this.formOptions = null;
    }
  }

  ngOnDestroy() {
    this.documentStoreService.documentFormComponent = null;
  }

  // Component methods
  calculateWordCount(reload: boolean = false, scope: DocumentFormComponent | null = null) {
    if(!scope){
      scope = this;
    }
    scope.totalWordCount = 0;
    let tinymceCssComponents: Array<TinymceCssComponent> = scope.tinymceCssComponents.toArray();
    if (reload && tinymceCssComponents && tinymceCssComponents.length > 0) {
      if (this.calculatingWordCount) return;
      this.calculatingWordCount = true;
      window.setTimeout(() => {
        let htmlArray: Array<string> = [];
        for (let documentPart of scope!.doc!.document_parts) htmlArray.push(documentPart.contents || '');
        scope!.documentService
          .calculateWordCount('', htmlArray)
          .then((response_json) => {
            for (let index in response_json.word_counts) scope!.totalWordCount += scope!.doc!.document_parts[Number(index)].word_count = scope!.doc!.document_parts[Number(index)].wordCount = response_json.word_counts[index];
            this.calculatingWordCount = false;
            this.documentChanged();
          })
          .catch(() => {
            this.calculatingWordCount = false;
          });
      }, 15000);
    } else for (let documentPart of scope.doc!.document_parts) scope.totalWordCount += documentPart.wordCount;
  }

  cancelTemplateSelection(scope: DocumentFormComponent) {
    scope.docTemplateTempItem = undefined;
    scope.docTemplateSearchComponent.docTemplateItem = scope.docTemplateItem;
    scope.docTemplateSearchComponent.documentTypes = [];
    scope.docTemplateSearchComponent.documentTypeSearchTerm = scope.docTemplateItem.document_type_name;
    scope.docTemplateSearchComponent.docTemplateSearchTerm = scope.docTemplateItem.label;
  }

  changeTemplate(scope: DocumentFormComponent) {
    scope.docTemplateItem = scope.docTemplateTempItem;
    scope.docTemplateTempItem = undefined;
    scope.alertService.alert_status_info_overlay('Loading Template <i class="fas fa-spinner fa-pulse fa-fw"></i>');
    if (!scope.formOptions)
      scope.documentService
        .getFormOptions({
          matter_id: scope.matter_id,
        })
        .then((response_json) => {
          scope.formOptions = response_json;
          scope.loadTemplate(scope);
        })
        .catch(function () {
          scope.alertService.alert_status_clear_overlay();
        });
    else scope.loadTemplate(scope);
  }

  documentChanged() {
    if (this.oldWordCount != this.totalWordCount) this.faviconService.faviconChange('danger');
    else this.faviconService.faviconChange('info');
  }

  cancelDocument() {
    this.documentStoreService.documentSidebarComponent!.cancelDocument();
  }

  documentLoaded(scope: DocumentFormComponent) {
    scope.alertService.alert_status_clear_overlay();
    if (scope.doc!.is_letter) scope.documentStoreService.documentSidebarComponent!.optionsExpand.letter_options = true;
    scope.documentStoreService.documentSidebarComponent!.optionsExpand.document_info = true;
    scope.matterStoreService.matterSidebarComponent!.sidebarExpand.documents = true;
    window.setTimeout(function () {
      scope.matterStoreService.matterShowComponent!.scrollToSidebarDocuments();
    }, 500);
    if (scope && scope.faviconService) scope.faviconService.faviconChange('info');
  }

  editDocument(document_id: number) {
    this.loggerService.console_log('editing document', document_id);
    /*this.documentChannelService.connectForDocumentEdit('test_id_123', false);
		let scope: DocumentFormComponent = this;
		window.setTimeout(() => {
			scope.documentChannelService.subscriptions.documentEditNotification.send({message: 'Test message'});
		}, 10000);
		return;*/
    this.alertService.alert_status_info_overlay('Loading Document <i class="fas fa-spinner fa-pulse fa-fw"></i>');
    this.loggerService.console_log('form options for documents', this.formOptions);
    if (!this.formOptions) {
      this.loggerService.console_log('fetching document form options');
      this.documentService
        .getFormOptions({
          matter_id: this.matter_id,
        })
        .then((response_json) => {
          this.loggerService.console_log('document form options success', response_json);
          try {
            this.formOptions = response_json;
            this.documentStoreService.documentSidebarComponent!.signatureUsers = response_json.signature_users;
            if (response_json.signature_matter_user_id && this.doc) this.doc!.signature_matter_user_id = response_json.signature_matter_user_id;
            this.documentStoreService.documentSidebarComponent!.letterContacts = response_json.letter_contacts;
            this.documentService.getDocumentEdit(document_id, this.matter_id).then((response_json) => {
              try {
                let documentSidebarComponent: DocumentSidebarComponent | null = this.documentStoreService.documentSidebarComponent;
                this.templateClass = response_json.template_class;
                this.docTemplate = response_json.doc_template;
                this.docParts = response_json.doc_parts;
                this.stylesheets_selected = response_json.stylesheets_selected;
                this.templateReturnData = response_json.template_return_data;
                documentSidebarComponent!.fontSize = response_json.font_size;
                documentSidebarComponent!.marginSettings = response_json.margin_settings;
                this.docTemplateItem = {
                  id: this.docTemplate!.id,
                  model: this.templateClass,
                  label: this.docTemplate!.name,
                  value: this.docTemplate!.name,
                };
                documentSidebarComponent!.tagsList = response_json.all_tags_list;
                this.doc = response_json.document;
                let documentParts: Array<DocumentPart> = [];
                for (let document_part of response_json.document_parts) {
                  let documentPart = new DocumentPart();
                  Object.assign(documentPart, document_part);
                  documentPart.isTinymce = documentPart.setIsTinymce();
                  documentParts.push(documentPart);
                }
                this.doc!.document_parts = documentParts;
                for (let documentPart of this.doc!.document_parts) documentPart.wordCount = documentPart.word_count;
                this.totalWordCount = response_json.total_word_count;
                this.templateWordCount = this.totalWordCount;
                this.oldWordCount = this.totalWordCount;
                documentSidebarComponent!.doc = this.doc;
                documentSidebarComponent!.documentToContacts = response_json.document_to_contacts;
                documentSidebarComponent!.documentCcContacts = response_json.document_cc_contacts;
                documentSidebarComponent!.documentBccContacts = response_json.document_bcc_contacts;
                for (var key in response_json.involvements) if (!documentSidebarComponent!.involvements[key] && response_json.involvements.hasOwnProperty(key)) documentSidebarComponent!.involvements[key] = response_json.involvements[key];
                this.docTemplateSearchComponent.docTemplateSelect({
                  id: this.docTemplateItem.id,
                  model: this.docTemplateItem.model,
                  label: this.docTemplateItem.label,
                  document_type_name: response_json.document_type_name,
                });
                this.loggerService.console_log('Form option success - Document edit tinymce components', this.tinymceCssComponents);
                this.loggerService.console_log('Form option success - Document edit tinymce components array', this.tinymceCssComponents.toArray());
                this.tinymceService.loadCSS(this.stylesheets_selected, this, this.tinymceCssComponents, this.documentLoaded);
              } catch (err) {
                this.loggerService.console_log('Error in document edit processing');
                console.error(err);
              }
            });
          } catch (err) {
            this.loggerService.console_log('Error in document form processing');
            console.error(err);
            this.alertService.alert_status_clear_overlay();
          }
        })
        .catch(() => {
          this.loggerService.console_log('document form options error upon/after fetch');
          this.alertService.alert_status_clear_overlay();
          this.documentService.getDocumentEdit(document_id, this.matter_id).then((response_json) => {
            let documentSidebarComponent = this.documentStoreService.documentSidebarComponent;
            this.templateClass = response_json.template_class;
            this.docTemplate = response_json.doc_template;
            this.docParts = response_json.doc_parts;
            this.stylesheets_selected = response_json.stylesheets_selected;
            this.templateReturnData = response_json.template_return_data;
            documentSidebarComponent!.fontSize = response_json.font_size;
            documentSidebarComponent!.marginSettings = response_json.margin_settings;
            this.docTemplateItem = {
              id: this.docTemplate!.id,
              model: this.templateClass,
              label: this.docTemplate!.name,
              value: this.docTemplate!.name,
            };
            documentSidebarComponent!.tagsList = response_json.all_tags_list;
            this.doc = response_json.document;
            let documentParts: Array<DocumentPart> = [];
            for (let document_part of response_json.document_parts) {
              let documentPart = new DocumentPart();
              Object.assign(documentPart, document_part);
              documentPart.isTinymce = documentPart.setIsTinymce();
              documentParts.push(documentPart);
            }
            this.doc!.document_parts = documentParts;
            for (let documentPart of this.doc!.document_parts) documentPart.wordCount = documentPart.word_count;
            this.totalWordCount = response_json.total_word_count;
            this.templateWordCount = this.totalWordCount;
            this.oldWordCount = this.totalWordCount;
            documentSidebarComponent!.doc = this.doc;
            documentSidebarComponent!.documentToContacts = response_json.document_to_contacts;
            documentSidebarComponent!.documentCcContacts = response_json.document_cc_contacts;
            documentSidebarComponent!.documentBccContacts = response_json.document_bcc_contacts;
            for (var key in response_json.involvements) if (!documentSidebarComponent!.involvements[key] && response_json.involvements.hasOwnProperty(key)) documentSidebarComponent!.involvements[key] = response_json.involvements[key];
            this.docTemplateSearchComponent.docTemplateSelect({
              id: this.docTemplateItem.id,
              model: this.docTemplateItem.model,
              label: this.docTemplateItem.label,
              document_type_name: response_json.document_type_name,
            });
            this.loggerService.console_log('Form option error - Document edit tinymce components', this.tinymceCssComponents);
            this.loggerService.console_log('Form option error - Document edit tinymce components array', this.tinymceCssComponents.toArray());
            this.tinymceService.loadCSS(this.stylesheets_selected, this, this.tinymceCssComponents, this.documentLoaded);
          });
        });
    } else {
      this.loggerService.console_log('document form options not fetched as already present', this.formOptions);
      this.documentService.getDocumentEdit(document_id, this.matter_id).then((response_json) => {
        let documentSidebarComponent = this.documentStoreService.documentSidebarComponent;
        this.templateClass = response_json.template_class;
        this.docTemplate = response_json.doc_template;
        this.docParts = response_json.doc_parts;
        this.stylesheets_selected = response_json.stylesheets_selected;
        this.templateReturnData = response_json.template_return_data;
        documentSidebarComponent!.fontSize = response_json.font_size;
        documentSidebarComponent!.marginSettings = response_json.margin_settings;
        this.docTemplateItem = {
          id: this.docTemplate!.id,
          model: this.templateClass,
          label: this.docTemplate!.name,
          value: this.docTemplate!.name,
        };
        documentSidebarComponent!.tagsList = response_json.all_tags_list;
        this.doc = response_json.document;
        let documentParts: Array<DocumentPart> = [];
        for (let document_part of response_json.document_parts) {
          let documentPart = new DocumentPart();
          Object.assign(documentPart, document_part);
          documentPart.isTinymce = documentPart.setIsTinymce();
          documentParts.push(documentPart);
        }
        this.doc!.document_parts = documentParts;
        for (let documentPart of this.doc!.document_parts) documentPart.wordCount = documentPart.word_count;
        this.totalWordCount = response_json.total_word_count;
        this.templateWordCount = this.totalWordCount;
        this.oldWordCount = this.totalWordCount;
        documentSidebarComponent!.doc = this.doc;
        documentSidebarComponent!.documentToContacts = response_json.document_to_contacts;
        documentSidebarComponent!.documentCcContacts = response_json.document_cc_contacts;
        documentSidebarComponent!.documentBccContacts = response_json.document_bcc_contacts;
        for (var key in response_json.involvements) if (!documentSidebarComponent!.involvements[key] && response_json.involvements.hasOwnProperty(key)) documentSidebarComponent!.involvements[key] = response_json.involvements[key];
        this.docTemplateSearchComponent.docTemplateSelect({
          id: this.docTemplateItem.id,
          model: this.docTemplateItem.model,
          label: this.docTemplateItem.label,
          document_type_name: response_json.document_type_name,
        });
        this.loggerService.console_log('Form option existing - Document edit tinymce components', this.tinymceCssComponents);
        this.loggerService.console_log('Form option existing - Document edit tinymce components array', this.tinymceCssComponents.toArray());
        this.tinymceService.loadCSS(this.stylesheets_selected, this, this.tinymceCssComponents, this.documentLoaded);
      });
    }
  }

  expandDocumentPart(documentPart: DocumentPart) {
    if (documentPart.expanded) {
      documentPart.expanded = false;
    } else {
      documentPart.expanded = true;
    }
  }

  generatingPreview(): boolean {
    return this.documentStoreService.documentSidebarComponent!.generatingPreview;
  }

  loadTemplate(scope: DocumentFormComponent | null = null, signature_matter_user_id: number | null = null) {
    if (!scope) scope = this;
    let params: any = { matter_id: scope.matter_id };
    if (scope.docTemplateItem.model == 'DocumentTemplate' || scope.docTemplateItem.model == 'document_template') params.document_template_id = scope.docTemplateItem.id;
    else params.doc_template_id = scope.docTemplateItem.id;
    scope.documentService.fetchTemplate(params).then((response_json) => {
      scope!.templateClass = response_json.template_class;
      scope!.docTemplate = response_json.doc_template;
      scope!.docParts = response_json.doc_parts;
      scope!.templateFooter = response_json.footer;
      scope!.templateHeader = response_json.header;
      scope!.stylesheets_selected = response_json.stylesheets_selected;
      scope!.css_content = response_json.css_content;

      scope!.docTemplate!.description = scope!.docTemplate!.description || scope!.docTemplate!.notes;

      scope!.templateReturnData = [];
      for (let docPart of scope!.docParts!) scope!.templateReturnData.push(docPart.return_data || {});
      scope!.documentStoreService.documentSidebarComponent!.canSendMailMerge = false;
      for (let returnData of scope!.templateReturnData)
        if (returnData.matters && (returnData.matters.conditions || returnData.matters.where_clause)) {
          if (returnData.matter_contacts && returnData.matter_contacts.conditions) scope!.documentStoreService.documentSidebarComponent!.canSendMailMerge = true;
          else if (returnData.matter_contact && returnData.matter_contact.conditions) scope!.documentStoreService.documentSidebarComponent!.canSendMailMerge = true;
        }
      scope!.doc = new Doc();
      if (signature_matter_user_id) {
        scope!.doc!.signature_matter_user_id = signature_matter_user_id;
        scope!.signature_matter_user_id = signature_matter_user_id;
      } else if (this.signature_matter_user_id) scope!.doc!.signature_matter_user_id = this.signature_matter_user_id;
      scope!.doc!.matter_id = scope!.matter_id;
      scope!.doc!.tag_list = scope!.docTemplate!.tag_list;
      scope!.doc!.is_letter = scope!.docTemplate!.is_letter;
      scope!.doc!.document_type_id = scope!.docTemplate!.document_type_id;
      if (scope!.docTemplateItem.model == 'DocumentTemplate' || scope!.docTemplateItem.model == 'document_template') scope!.doc!.document_template_id = scope!.docTemplateItem.id;
      else scope!.doc!.doc_template_id = scope!.docTemplateItem.id;
      scope!.documentStoreService.documentSidebarComponent!.doc = scope!.doc;
      // parse_doc_parts builds doc.document_parts asynchronously in an iframe.
      // The default recipient must be applied after that work completes because
      // addDocumentContact immediately writes the inside-address and salutation
      // parts. Applying it here used to throw while document_parts was undefined,
      // leaving the generated letter with no recipient records.
      scope!.parse_doc_parts(response_json.css_content, null, response_json.default_to_involvement);
      scope!.documentStoreService.documentSidebarComponent!.subscribeToTimer();
      if (scope && scope.faviconService) scope.faviconService.faviconChange('info');
      if (scope!.docTemplate!.activity_id && scope!.matterStoreService.billingRecordTimeComponent) scope!.matterStoreService.billingRecordTimeComponent.setActivity(scope!.docTemplate!.activity_id);
    });
  }

  newDocument() {
    this.doc = null;
    this.templateReturnData = null;
    this.docTemplateItem = null;
    this.docTemplate = null;
    this.docParts = null;
    this.stylesheets_selected = null;
    this.docTemplateTempItem = null;
    this.templateFooter = null;
    this.templateHeader = null;
    this.templateClass = null;
    this.matterStoreService.matterShowComponent!.listDocumentTabActive = false;
    this.matterStoreService.matterShowComponent!.newDocumentTabActive = true;
    this.docTemplateSearchComponent.clearSelectedDocTemplate();
    this.faviconService.faviconChange();
  }

  newSidebarDocument() {
    this.documentStoreService.documentSidebarComponent!.newDocument();
  }

  onTemplateSelection(doc_template_item: any, noPromptBillingSave: boolean = false): void {
    if (noPromptBillingSave || !this.matterStoreService.is_matter_user || !this.matterStoreService.billingRecordTimeComponent)
      if (this.docTemplateItem) {
        let confirmModal = this.modalService.confirmModal;
        confirmModal.modal_header = 'Template change';
        confirmModal.modal_body = 'Changing template will erase changes done so far. Do you wish to proceed?';
        confirmModal.modal_confirm = 'Confirm';
        confirmModal.modal_cancel = 'Cancel';
        confirmModal.confirm_function = this.changeTemplate;
        confirmModal.cancel_function = this.cancelTemplateSelection;
        confirmModal.current_scope = this;
        this.docTemplateTempItem = doc_template_item;
        confirmModal.openModal();
      } else {
        let scope = this;
        this.alertService.alert_status_info_overlay('Loading Template <i class="fas fa-spinner fa-pulse fa-fw"></i>');
        this.docTemplateItem = doc_template_item;
        if (!this.formOptions)
          this.documentService
            .getFormOptions({
              matter_id: this.matter_id,
            })
            .then((response_json) => {
              this.formOptions = response_json;
              this.documentStoreService.documentSidebarComponent!.signatureUsers = response_json.signature_users;
              //if(response_json.signature_matter_user_id)
              //	this.doc!.signature_matter_user_id = response_json.signature_matter_user_id;
              this.documentStoreService.documentSidebarComponent!.letterContacts = response_json.letter_contacts;
              this.loadTemplate(null, response_json.signature_matter_user_id);
            })
            .catch(function (err) {
              scope.alertService.alert_status_clear_overlay();
              scope.loggerService.console_log(err);
            });
        else this.loadTemplate();
      }
    else
      this.matterStoreService.billingRecordTimeComponent.promptBillingSave('document')!.then((value) => {
        if (value == 'cancel') return;
        this.loggerService.console_log('promise resolved');
        if (this.docTemplateItem) {
          let confirmModal = this.modalService.confirmModal;
          confirmModal.modal_header = 'Template change';
          confirmModal.modal_body = 'Changing template will erase changes done so far. Do you wish to proceed?';
          confirmModal.modal_confirm = 'Confirm';
          confirmModal.modal_cancel = 'Cancel';
          confirmModal.confirm_function = this.changeTemplate;
          confirmModal.cancel_function = this.cancelTemplateSelection;
          confirmModal.current_scope = this;
          this.docTemplateTempItem = doc_template_item;
          confirmModal.openModal();
        } else {
          let scope = this;
          this.alertService.alert_status_info_overlay('Loading Template <i class="fas fa-spinner fa-pulse fa-fw"></i>');
          this.docTemplateItem = doc_template_item;
          if (!this.formOptions)
            this.documentService
              .getFormOptions({
                matter_id: this.matter_id,
              })
              .then((response_json) => {
                this.formOptions = response_json;
                this.documentStoreService.documentSidebarComponent!.signatureUsers = response_json.signature_users;
                //if(response_json.signature_matter_user_id)
                //	this.doc!.signature_matter_user_id = response_json.signature_matter_user_id;
                this.documentStoreService.documentSidebarComponent!.letterContacts = response_json.letter_contacts;
                this.loadTemplate(null, response_json.signature_matter_user_id);
              })
              .catch(function (err) {
                scope.alertService.alert_status_clear_overlay();
                scope.loggerService.console_log(err);
              });
          else this.loadTemplate();
        }
      });
  }

  previewDocument(inline: boolean = false) {
    this.documentStoreService.documentSidebarComponent!.previewDocument(inline);
  }

  saveAndCloseDocument() {
    this.documentStoreService.documentSidebarComponent!.saveAndCloseDocument();
  }

  saveDocument() {
    this.documentStoreService.documentSidebarComponent!.saveDocument();
  }

  parse_doc_parts(css_content: any, scope: any = null, defaultToInvolvement: any = null) {
    if (!scope) scope = this;
    if (jQuery('#hidden_div_end').length < 1) jQuery('body').append('<div id="hidden_div_end" style="position: fixed; top: 10000px; left: 0px; width: 100%;"><iframe id="iframe_document_prep" style="width: 100%;"></iframe></div>');
    var iframe = jQuery('#hidden_div_end').children('iframe').get(0);
    var html = scope.formOptions.preview_template_scripts_css + '<style type="text/css">' + css_content + '</style>' + scope.formOptions.preview_template + "<div id='document_parts_content_holder' class='parts_wrapper' style='PalatinoRoman';font-size:12pt;>";
    html += '<div id="document_parts_content_header">';
    html += scope.templateHeader;
    html += '</div>';
    for (let i in scope.docParts) {
      html += '<div id="document_parts_content_' + i + '">';
      html += scope.docParts[i].contents;
      html += '</div>';
    }
    html += '<div id="document_parts_content_footer">';
    html += scope.templateFooter;
    html += '</div>';
    html += '</div>';
    html += '<script type="text/javascript">jQuery(document).ready(function(){loader_fn_ptemplate();});</script>';
    iframe.srcdoc = html;
    iframe.onload = function () {
      window.setTimeout(function () {
        scope.templateHeader = iframe.contentDocument.getElementById('document_parts_content_header').innerHTML;
        for (let i in scope.docParts) scope.docParts[i].contents = iframe.contentDocument.getElementById('document_parts_content_' + i).innerHTML;
        scope.templateFooter = iframe.contentDocument.getElementById('document_parts_content_footer').innerHTML;
        jQuery(iframe).parent().remove();
        let documentParts = [];
        let documentPart = new DocumentPart();
        Object.assign(documentPart, {
          name: 'Header',
          contents: scope.templateHeader,
          expand_part: false,
          include_part: true,
        });
        documentPart.expanded = documentPart.expand_part || false;
        documentPart.isTinymce = documentPart.setIsTinymce();
        documentParts.push(documentPart);
        for (let docPart of scope.docParts) {
          let documentPart: DocumentPart = new DocumentPart();
          // Hack to access object using indices
          let partScope: any = documentPart;
          for (let docPartColumn of scope.docPartColumns) partScope[docPartColumn] = docPart[docPartColumn];
          partScope['include_part'] = docPart['mandatory'];
          documentPart.expanded = documentPart.expand_part || false;
          documentPart.isTinymce = documentPart.setIsTinymce();
          documentParts.push(documentPart);
        }
        documentPart = new DocumentPart();
        Object.assign(documentPart, {
          name: 'Footer',
          contents: scope.templateFooter,
          expand_part: false,
          include_part: true,
        });
        documentPart.expanded = documentPart.expand_part || false;
        documentPart.isTinymce = documentPart.setIsTinymce();
        documentParts.push(documentPart);
        scope.doc!.document_parts = documentParts;
        scope.applyDefaultToInvolvement(scope, defaultToInvolvement);
        let html: string = '';
        let htmlArray: Array<string> = [];
        for (let documentPart of scope.doc!.document_parts) {
          html += documentPart.contents || '';
          htmlArray.push(documentPart.contents);
        }
        scope.documentService.calculateWordCount(html, htmlArray).then((response_json: any) => {
          scope.loggerService.console_log('calculate word count');
          scope.totalWordCount = 0; //response_json.total_word_count;
          for (let index in response_json.word_counts) {
            scope.doc!.document_parts[index].word_count = scope.doc!.document_parts[index].wordCount = response_json.word_counts[index];
            scope.totalWordCount += scope.doc!.document_parts[index].wordCount;
          }
          scope.templateWordCount = scope.totalWordCount;
          scope.oldWordCount = scope.totalWordCount;
          scope.loggerService.console_log(scope.totalWordCount, scope.templateWordCount, scope.oldWordCount, scope.doc!.document_parts);
        });
        scope.loggerService.console_log('tinymce css components', scope.tinymceCssComponents);
        scope.loggerService.console_log(scope.tinymceCssComponents.toArray());
        scope.tinymceService.loadCSS(scope.stylesheets_selected, scope, scope.tinymceCssComponents, scope.templateLoaded);
      }, 1000);
    };
  }

  applyDefaultToInvolvement(scope: DocumentFormComponent, involvement: any) {
    if (!involvement) return;

    const sidebar = scope.documentStoreService.documentSidebarComponent!;
    if (sidebar.documentToContacts.some((contact) => contact.involvement_id == involvement.id)) return;

    sidebar.involvements[involvement.id] = involvement;
    sidebar.addDocumentContact(involvement, 'To');
  }

  templateLoaded(scope: DocumentFormComponent) {
    scope.alertService.alert_status_clear_overlay();
    if (scope.doc!.is_letter) {
      if (!scope.doc!.signature_matter_user_id && scope.documentStoreService.documentSidebarComponent!.signatureUsers[0]) scope.doc!.signature_matter_user_id = scope.documentStoreService.documentSidebarComponent!.signatureUsers[0].id;
      scope.documentStoreService.documentSidebarComponent!.optionsExpand.letter_options = true;
    }
    scope.documentStoreService.documentSidebarComponent!.optionsExpand.document_info = true;
    scope.matterStoreService.matterSidebarComponent!.sidebarExpand.documents = true;
    window.setTimeout(function () {
      scope.matterStoreService.matterShowComponent!.scrollToSidebarDocuments();
    }, 500);
  }
}
